"use strict";

angular.module('app.modals.statistic', [])

    .controller('statisticModalCtrl', ['$scope', '$rootScope', '$filter', '$timeout', '$q', 'statisticFor', 'close', 'xCenterConfig', 'API', 'dateTimePickerModal',
        function($scope, $rootScope, $filter, $timeout, $q, statisticFor, close, xCenterConfig, API, dateTimePickerModal) {

            // Init Alarm

            $scope.statisticHeight = 480;
            $scope.statisticWidth = 800;
            //$scope.stepsX = 30;
            //$scope.periodType = 0;
            $scope.dateFormat = 'dd.MM.yyyy';
            $scope.entryFormat = 'dd.MM';
            $scope.toDate = false;
            $scope.loadStats = true;

            $scope.init = function() {
                $scope.$emit('loading-start');
                $scope.loadStats = true;
                $scope.statistic = statisticFor;
                // console.log('INIT WITH STATISTICOBJECT');
                if ($scope.statistic) {
                    if ($scope.statistic.PeriodType != undefined) {

                        $scope.periodType = $scope.statistic.PeriodType;

                    } else {
                        $scope.periodType = 0;
                    }
                    // $rootScope.loading = true;

                    // $scope.loading = 'WIDGET_STATISTIC_LoadingData';

                    $scope.max = 0;
                    $scope.min = 0;
                    var deviceIds = [];
                    for (var i = 0; i < $scope.statistic.Datapoints.length; i++) {
                        var DeviceId = $scope.statistic.Datapoints[i].DeviceId;
                        if (deviceIds[DeviceId] === undefined) {
                            deviceIds[DeviceId] = [];
                        }

                        deviceIds[DeviceId].push($scope.statistic.Datapoints[i].DatapointConfigId);
                    }

                    var qList = [];
                    $scope.yAxis = [];
                    $scope.xAxis = [];
                    let promises = [];

                    for (var key in deviceIds) {
                        if (deviceIds.hasOwnProperty(key)) {
                            let defer = $q.defer();
                            qList.push(defer);
                            let statisticParams = {
                                "DeviceId": key,
                                "ConfigIds": deviceIds[key],
                                "FromUTC": $scope.statistic.FromUTC,
                                "ToUTC": $scope.statistic.ToUTC,
                                "Period": $scope.statistic.Period,
                            };
                            var _API = new API();
                            promises.push(_API.Statistic.GetStatistic(statisticParams).$promise);
                        }
                    }
                    $q.all(promises)
                    .then(function(data) {
                        $scope.statisticValues = [];
                        for (var i = 0; i < data.length; i++) {
                            computeGraphData(data[i], qList[i]);
                        }
                    }, function() {
                        close();
                    })
                    .finally(function() {
                        $rootScope.loading = false;
                        $scope.loading = false;
                        $scope.loadStats = false;
                        $scope.$emit('loading-stop');
                    })
                    .catch(function() {
                        $rootScope.loading = false;
                        $scope.loading = false;
                        $scope.loadStats = false;
                        $scope.$emit('loading-stop');
                    });
                }

            };

            function computeGraphData(data, deferred) {
                $scope.offsetY = 0;
                $scope.offsetX = 5;

                if (data.length === 0) {
                    deferred.resolve();
                }
                for (var j = 0; j < $scope.statistic.Datapoints.length; j++) {
                    var dp = $scope.statistic.Datapoints[j];
                    var list = $filter('filter')(data, function(value) {
                        if (
                            value.Value.DatapointConfigId == dp.DatapointConfigId &&
                            value.Value.DeviceId == dp.DeviceId &&
                            value.Value != 'NaN'
                        ) {
                            return true;
                        } else {
                            return false;
                        }
                    });

                    /* Any datapoint with identical name? */
                    let identicalNamesMap = {};
                    let identicalName = false;
                    for (let i = 0; i < $scope.statistic.Datapoints.length; i++) {
                        const dp = $scope.statistic.Datapoints[i];

                        if (identicalNamesMap[dp.DisplayName] === undefined) {
                            identicalNamesMap[dp.DisplayName] = true;
                        } else {
                            identicalName = true;
                            break;
                        }
                    }

                    if (list.length > 0) {
                        for (var i = list.length - 1; i >= 0; i--) {
                            let serverTimeUtc = moment.utc(list[i].TimeStampUtc);
                            list[i].TimeStampUtc = serverTimeUtc;
                            if (serverTimeUtc.diff($scope.statistic.FromUTC) < 0) {
                                list.splice(i, 1);

                                continue;
                            }
                            if (serverTimeUtc.diff($scope.statistic.ToUTC) > 0) {
                                list.splice(i, 1);

                                continue;
                            }
                            if (list[i].Value.Value != "NaN" && ($scope.max == undefined || parseFloat(list[i].Value.Value) > parseFloat($scope.max))) {

                                $scope.max = list[i].Value.Value;

                            }

                            if (list[i].Value.Value != "NaN" && ($scope.min == undefined || parseFloat(list[i].Value.Value) < parseFloat($scope.min))) {

                                $scope.min = list[i].Value.Value;
                            }
                            /* console.log({
                                 Max:$scope.max,
                                 Min:$scope.min,
                                 Val:list[i].Value.Value
                             });*/
                        }

                        let deviceDifference = '';
                        if (identicalName) {
                            deviceDifference = ' (' + dp.Device.Device.Name + ')';
                        }

                        list.$DisplayName = dp.DisplayName + deviceDifference;
                        list.$Unit = dp.Config.Unit;
                        list.DeviceId = dp.DeviceId;

                        $scope.statisticValues.push(list);
                        list.$color = conf_graph_colors[($scope.statisticValues.length - 1)];

                    }
                }

                computeLegendNamesLengths();

                /* Quick hack with unreasonable min and max values */
                if ($scope.max !== $scope.min && $scope.max - $scope.min < 1) {
                    $scope.max = Math.ceil($scope.max);
                    $scope.min = Math.floor($scope.min);
                }

                $scope.statisticValuesMax = $scope.max;
                $scope.statisticValuesMin = $scope.min;
                if ($scope.min === $scope.max) {
                    $scope.max = $scope.max + 1;
                }
                var delta;
                delta = Math.abs($scope.max + (-1 * $scope.min));


                $scope.delta = delta;

                var parseSteps = function(a, d) {
                    var b = String(a);
                    var c = '1';
                    for (i = 1; i < b.length + d; i++) {
                        c = c + '0';
                    }
                    return c;
                };

                var minBorder;
                var maxBorder;
                if (delta >= 1) {
                    minBorder = $scope.min - (delta * xCenterConfig.statistic.delta_percent);
                    maxBorder = $scope.max + (delta * xCenterConfig.statistic.delta_percent);

                    $scope.step = parseInt(parseSteps(parseInt(delta), 0));
                } else if (delta == 0) {
                    $scope.step = 1 * xCenterConfig.statistic.delta_percent;

                    minBorder = $scope.min - (xCenterConfig.statistic.delta_percent);
                    maxBorder = $scope.max + (xCenterConfig.statistic.delta_percent);
                    delta = 1;
                } else {
                    // delta is smaller than ß
                    // var ndelta = 1 / (Math.floor(1 / delta));

                    /* Quick hack with substitute delta with 1 */
                    $scope.step = parseInt(parseSteps(parseInt(1), 0));

                    minBorder = $scope.min - (1 * xCenterConfig.statistic.delta_percent);
                    maxBorder = $scope.max + (1 * xCenterConfig.statistic.delta_percent);
                }

                // calculate X and Y values
                var divider = 1;
                var adder = 0;
                var differenceUnit;
                switch ($scope.periodType) {
                    case 0:
                        differenceUnit = 'hours';
                        divider = 1;
                        adder = 1;
                        break;
                    case 1:
                        differenceUnit = 'hours';
                        divider = 6;
                        adder = 0;
                        break;
                    case 2:
                        differenceUnit = 'days';
                        divider = 1;
                        adder = 0;
                        break;
                    case 3:
                        differenceUnit = 'months';
                        divider = 1;
                        adder = 0;
                        break;


                }
                $scope.stepsX = $scope.statistic.FromUTC.diff($scope.statistic.ToUTC, differenceUnit);

                $scope.stepsX = Math.abs($scope.stepsX / divider);


                // Subtract one Step, because the last value is one Step from left. (grid of the statistic is the size plus one step)
                var realWidth = ($scope.statisticWidth - $scope.offsetX);
                var onStepX = (realWidth / ($scope.stepsX + adder));

                var deltaBorderValue = xCenterConfig.statistic.delta_percent * delta;
                var maxWithBorderValue = Math.abs(maxBorder - minBorder);
                var ValuePx = $scope.statisticHeight / maxWithBorderValue;


                for (let i = 0; i < $scope.statisticValues.length; i++) {
                    for (let j = 0; j < $scope.statisticValues[i].length; j++) {

                        var o = $scope.statisticValues[i][j];
                        var diff = o.TimeStampUtc.diff($scope.statistic.FromUTC, differenceUnit);
                        var aktStep = (diff / divider);
                        var pointOffsetLeft = onStepX * aktStep;
                        var deltaAktValue = (o.Value.Value - $scope.min);

                        o.Value.y = ((deltaAktValue + deltaBorderValue) / maxWithBorderValue) * $scope.statisticHeight;
                        o.Value.x = pointOffsetLeft - $scope.offsetX;
                        o.Value.DisplayText = deltaAktValue;
                    }
                }

                var yAxisSteps = maxWithBorderValue / $scope.step;
                if (yAxisSteps > 1000000) {
                    console.error('Statistic computation error, yAxisSteps higher than reasonable amount: ' + yAxisSteps);
                    return;
                }
                $scope.stepsAll = Math.floor((delta / $scope.step)) + 1;
                $scope.yAxis = [];
                var oneStepPx = ValuePx * $scope.step;
                var toFirstLabel = (($scope.step - (minBorder % $scope.step)) / $scope.step) * oneStepPx;

                for (let i = 0; i < yAxisSteps; i++) {
                    var y = (((i - 1) * (oneStepPx)) + toFirstLabel);
                    var val = {
                        "y": y,
                        "Value": (minBorder + ($scope.step - (minBorder % $scope.step)) + ((i - 1) * $scope.step))
                    };
                    if (val.Value <= maxBorder && val.Value >= minBorder) {
                        $scope.yAxis.push(val);
                    }

                }


                $scope.xAxis = [];

                var m = $scope.statistic.FromUTC;
                var b = $scope.statistic.ToUTC;
                var timeUnit, timeUnitFormat, timeUnitString;
                switch ($scope.periodType) {
                    case 0:
                        // Do xAxis for Day
                        var len = b.diff(m, 'hours') + 1;
                        timeUnit = 'hours';
                        timeUnitFormat = 'H';
                        timeUnitString = 'Hour';
                        $scope.timeUnitFormPoints = "HH:m";
                        $scope.pointTimeFormat = "HH:mm";
                        break;
                    case 1:
                        // Do xAxis for Week
                        len = b.diff(m, 'days') + 1;
                        timeUnit = 'days';
                        timeUnitFormat = 'ddd';

                        $scope.timeUnitFormPoints = "D dd HH:m";
                        $scope.pointTimeFormat = "ddd[\xa0]DD.MM HH:mm";
                        break;
                    case 2:
                        // Do xAxis for Month
                        len = b.diff(m, 'days');
                        timeUnit = 'days';
                        timeUnitFormat = 'D';
                        $scope.timeUnitFormPoints = "dd D";
                        $scope.pointTimeFormat = "ddd[\xa0]DD.MM";

                        break;
                    case 3:
                        // Do xAxis for Year
                        len = b.diff(m, 'month');
                        timeUnit = 'months';
                        timeUnitFormat = 'MMM';
                        $scope.timeUnitFormPoints = "M.YYYY";
                        $scope.pointTimeFormat = "MMMM YYYY";
                        break;
                }

                for (let i = 1; i <= len; i++) {
                    var b = moment.utc($scope.statistic.FromUTC).local();

                    $scope.xAxis.push({
                        "DisplayText": b.add((i - 1), timeUnit).format(timeUnitFormat),
                        "Percent": (((i - 1) / (len)) * 100)
                    });
                }
                var o = {
                    yAxis: $scope.yAxis,
                    xAxis: $scope.xAxis,
                    values: $scope.statisticValues
                };
                $rootScope.$broadcast('curve_update', o);
                $timeout(function() {
                    var o = {
                        yAxis: $scope.yAxis,
                        xAxis: $scope.xAxis,
                        values: $scope.statisticValues
                    };
                    $rootScope.$broadcast('curve_update', o);
                    deferred.resolve();
                }, 100);
            }

            function computeLegendNamesLengths() {
                let totalLength = 0.0;
                const bordersWidth = 50;
                const pointWidth = 15;
                const spaceBetweenEntries = 20;
                $scope.statisticValues.forEach(function(datapointStatistic) {
                    totalLength += pointWidth
                                    + toInteger(calculateTextLength(datapointStatistic.$DisplayName))
                                    + toInteger(calculateTextLength(' ' + datapointStatistic.$Unit))
                                    + spaceBetweenEntries;
                });

                if ($scope.statisticWidth - bordersWidth < totalLength) {
                    /* Total text too long, we have to shorten it. */
                    const lengthReductionMultiplier = ($scope.statisticWidth - bordersWidth) / totalLength;
                    $scope.statisticValues.forEach(function(datapointStatistic) {
                        /* -1 for ellipses char */
                        let numberOfAllowedChars = Math.floor(datapointStatistic.$DisplayName.length * lengthReductionMultiplier) - 1;
                        datapointStatistic._DisplayName = datapointStatistic.$DisplayName.substring(0, numberOfAllowedChars) + '…';
                    });
                }
                else {
                    $scope.statisticValues.forEach(function(datapointStatistic) {
                        datapointStatistic._DisplayName = datapointStatistic.$DisplayName;
                    });
                }
            }

            function toInteger(x) {
                x = Number(x);
                return x < 0 ? Math.ceil(x) : Math.floor(x);
            }

            function calculateTextLength(text) {
                // re-use canvas object for better performance
                let canvas = $scope.textLengthCanvas || ($scope.textLengthCanvas = document.createElement("canvas"));
                let context = canvas.getContext("2d");
                context.font = "normal 14px Open Sans";
                let metrics = context.measureText(text);
                return metrics.width;
            }

            $scope.setPeriod = function(p) {
                $scope.loading = true;

                switch (p) {
                    case 0:
                        $scope.statistic.FromUTC = moment($scope.statistic.FromUTC.local()).startOf('day').utc();
                        $scope.statistic.ToUTC = moment($scope.statistic.FromUTC).local().endOf('day').add({ second: 1 }).utc();

                        $scope.statistic.Period = 1;
                        $scope.statistic.PeriodType = 0;
                        $scope.dateFormat = 'dd.MM.yyyy';
                        $scope.entryFormat = 'HH:mm';
                        $scope.toDate = false;

                        break;
                    case 1:
                        $scope.statistic.FromUTC = moment($scope.statistic.FromUTC.local()).startOf('week').utc();
                        $scope.statistic.ToUTC = moment($scope.statistic.FromUTC).local().endOf('week').add({ hour: 1 }).utc();

                        $scope.statistic.Period = 2;
                        $scope.statistic.PeriodType = 1;
                        $scope.dateFormat = 'dd.MM.yyyy';
                        $scope.entryFormat = 'EEE';
                        $scope.toDate = true;
                        break;
                    case 2:
                        $scope.statistic.FromUTC = moment($scope.statistic.FromUTC.local()).startOf('month').utc();
                        $scope.statistic.ToUTC = moment($scope.statistic.FromUTC).local().endOf('month').add({ day: 1 }).utc();

                        $scope.statistic.Period = 3;
                        $scope.statistic.PeriodType = 2;
                        $scope.dateFormat = 'dd.MM.yyyy';
                        $scope.entryFormat = 'dd.MM';
                        $scope.toDate = true;
                        break;
                    case 3:
                        $scope.statistic.FromUTC = moment($scope.statistic.FromUTC.local()).startOf('year').utc();
                        $scope.statistic.ToUTC = moment($scope.statistic.FromUTC).local().endOf('year').add({ day: 1 }).utc();

                        $scope.statistic.Period = 4;
                        $scope.statistic.PeriodType = 3;
                        $scope.dateFormat = 'dd.MM.yyyy';
                        $scope.entryFormat = 'MM.YYYY';
                        $scope.toDate = true;

                        break;
                }


                $scope.init();
            };

            $scope.prevDate = function() {
                $scope.loading = true;
                var o;
                var eo;
                var toAdd;
                switch ($scope.periodType) {
                    case 0:
                        o = { days: 1 };
                        eo = 'day';
                        toAdd = { seconds: 1 };
                        break;
                    case 1:
                        o = { week: 1 };
                        eo = 'week';
                        toAdd = { day: 1 };
                        break;
                    case 2:
                        o = { month: 1 };
                        eo = 'month';
                        toAdd = { seconds: 1 };
                        break;
                    case 3:
                        o = { year: 1 };
                        eo = 'year';
                        toAdd = { day: 1 };
                        break;
                }

                $scope.statistic.FromUTC = moment($scope.statistic.FromUTC.local()).subtract(o).startOf(eo).utc();
                $scope.statistic.ToUTC = moment($scope.statistic.FromUTC).local().endOf(eo).add(toAdd).utc();
                console.log('prevDate: ' + $scope.statistic.FromUTC.local().format('DD.MM.YYYY HH:mm:ss Z') + ' - ' + $scope.statistic.ToUTC.local().format('DD.MM.YYYY HH:mm:ss Z'));
                $scope.init();

            };
            $scope.nextDate = function() {
                $scope.loading = true;
                var o;
                var eo;
                var toAdd;
                switch ($scope.periodType) {
                    case 0:
                        o = { days: 1 };
                        eo = 'day';
                        toAdd = { seconds: 1 };
                        break;
                    case 1:
                        o = { week: 1 };
                        eo = 'week';
                        toAdd = { day: 1 };
                        break;
                    case 2:
                        o = { month: 1 };
                        eo = 'month';
                        toAdd = { seconds: 1 };
                        break;
                    case 3:
                        o = { year: 1 };
                        eo = 'year';
                        toAdd = { days: 1 };
                        break;
                }
                $scope.statistic.FromUTC = moment($scope.statistic.FromUTC.local()).add(o).startOf(eo).utc();
                $scope.statistic.ToUTC = moment($scope.statistic.FromUTC).local().endOf(eo).add(toAdd).utc();
                console.log('nextDate: ' + $scope.statistic.FromUTC.local().format('DD.MM.YYYY HH:mm:ss Z') + ' - ' + $scope.statistic.ToUTC.local().format('DD.MM.YYYY HH:mm:ss Z'));

                $scope.init();

            };

            $scope.close = function() {
                close();
            };

            $scope.selectDate = function () {
                let toAdd;

                dateTimePickerModal(moment($scope.statistic.FromUTC).local(), { hideTime: true })
                .then(function(modal) {
                    modal.close.then(function(data) {
                        if (data) {
                            $scope.loading = true;
                            // console.log(data);
                            var eo;
                            switch ($scope.periodType) {
                                case 0:
                                    eo = 'day';
                                    toAdd = {
                                        seconds: 1
                                    };
                                    break;
                                case 1:
                                    eo = 'week';
                                    toAdd = {
                                        day: 1
                                    };
                                    break;
                                case 2:
                                    eo = 'month';
                                    toAdd = {
                                        seconds: 1
                                    };
                                    break;
                                case 3:
                                    eo = 'year';
                                    toAdd = {
                                        days: 1
                                    };
                                    break;
                            }
                            $scope.statistic.FromUTC = moment(data).startOf(eo).utc();
                            $scope.statistic.ToUTC = moment(data).endOf(eo).add(toAdd).utc();

                            $scope.init();
                        }
                    });
                });



            };
            $scope.init();


        }
    ])

    .factory('statisticModal', ['ModalService', function(ModalService) {
        return function(statisticFor) {

            return ModalService.showModal({
                templateUrl: "views/modals/statistic.html",
                controller: 'statisticModalCtrl',
                inputs: {
                    statisticFor: statisticFor
                }
            });


        };
    }]);
